import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import { FuelSurchargeSchedule } from '~hooks/useFuelSurchargeSchedule/model';

interface FuelSurchargeScheduleRowProps {
  schedule: FuelSurchargeSchedule;
  isSelected: boolean;
  onSelect: (id: string) => void;
  onEdit: (schedule: FuelSurchargeSchedule, event: React.MouseEvent) => void;
  onDelete: (schedule: FuelSurchargeSchedule, event: React.MouseEvent) => void;
}

export const FuelSurchargeScheduleRow = ({
  schedule,
  isSelected,
  onSelect,
  onEdit,
  onDelete,
}: FuelSurchargeScheduleRowProps) => {
  const theme = useTheme();

  return (
    <ListItemButton
      key={schedule.id}
      onClick={() => onSelect(schedule.id)}
      selected={isSelected}
      sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRight: isSelected ? `2px solid ${theme.palette.primary.main}` : '',
        flex: 0,
        minHeight: 48,
        position: 'relative',
        '&:hover': {
          '& .action-buttons': {
            opacity: 1,
          },
        },
      }}
    >
      <ListItemText
        primary={schedule.name}
        sx={{
          fontWeight: 600,
          pr: 6,
        }}
      />
      <Box
        className="action-buttons"
        sx={{
          position: 'absolute',
          right: 8,
          top: '50%',
          transform: 'translateY(-50%)',
          display: 'flex',
          gap: 0.5,
          opacity: 0,
          transition: 'opacity 0.2s',
        }}
      >
        <IconButton size="small" onClick={(e) => onEdit(schedule, e)}>
          <Edit fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={(e) => onDelete(schedule, e)}>
          <Delete fontSize="small" />
        </IconButton>
      </Box>
    </ListItemButton>
  );
};
